const cleanHandle = (raw: string, label: string) => {
  const value = raw.trim().replace(/^@/, '');
  if (!value || !/^[A-Za-z0-9._-]+$/.test(value)) {
    throw new Error(`Enter a valid ${label} username or handle, not a URL.`);
  }
  return value;
};

const httpsURL = (raw: string, label: string) => {
  try {
    const url = new URL(raw.trim());
    if (url.protocol !== 'https:') throw new Error();
    return url;
  } catch {
    throw new Error(`Enter a valid public ${label} URL beginning with https://.`);
  }
};

export const socialHandleInput = (raw: string) => cleanHandle(raw, 'social');

export const linkedinProfileInput = (raw: string) => {
  const url = httpsURL(raw, 'LinkedIn profile');
  const host = url.hostname.toLowerCase();
  if ((host !== 'linkedin.com' && !host.endsWith('.linkedin.com')) || !/^\/in\/[^/]+\/?$/.test(url.pathname)) {
    throw new Error('Enter a valid public LinkedIn profile URL.');
  }
  return url.toString().replace(/\/$/, '');
};

export const youtubeChannelInput = (raw: string): { handle: string } | { channelId: string } => {
  const value = raw.trim();
  if (!value.includes('://')) return { handle: `@${cleanHandle(value, 'YouTube channel')}` };
  const url = httpsURL(value, 'YouTube channel');
  const host = url.hostname.toLowerCase();
  if (host !== 'youtube.com' && !host.endsWith('.youtube.com')) {
    throw new Error('Enter a valid YouTube channel handle or URL.');
  }
  const parts = url.pathname.split('/').filter(Boolean);
  if (parts.length === 1 && parts[0]?.startsWith('@')) {
    return { handle: `@${cleanHandle(parts[0], 'YouTube channel')}` };
  }
  if (parts.length === 2 && parts[0] === 'channel') {
    return { channelId: cleanHandle(parts[1] ?? '', 'YouTube channel') };
  }
  throw new Error('Enter a valid YouTube channel handle or URL.');
};

export const snapchatProfileInput = (raw: string) => {
  const value = raw.trim();
  if (!value.includes('://')) return { username: cleanHandle(value, 'Snapchat') };
  const url = httpsURL(value, 'Snapchat profile');
  const host = url.hostname.toLowerCase();
  const parts = url.pathname.split('/').filter(Boolean);
  if ((host !== 'snapchat.com' && !host.endsWith('.snapchat.com')) || parts[0] !== 'add' || parts.length !== 2) {
    throw new Error('Enter a valid Snapchat username or public profile URL.');
  }
  return { username: cleanHandle(parts[1] ?? '', 'Snapchat') };
};

export const socialFinderInput = (raw: string) => {
  const name = raw.trim().replace(/^@/, '');
  if (!name || !/^[A-Za-z0-9._-]+$/.test(name)) {
    throw new Error('Enter a username using letters, numbers, dots, underscores, or hyphens.');
  }
  return { name, limit: 10 };
};
